module.exports = __webpack_public_path__ + "img/background_illustration_NOSOTROS.38db6f20.svg";